import { render } from "./CustomCombobox.vue?vue&type=template&id=c6cd27ca&scoped=true&ts=true"
import script from "./CustomCombobox.vue?vue&type=script&lang=ts"
export * from "./CustomCombobox.vue?vue&type=script&lang=ts"

import "./CustomCombobox.vue?vue&type=style&index=0&id=c6cd27ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6cd27ca"]])

export default __exports__